var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 577.8",
    style: {
      enableBackground: "new 0 0 800 577.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00247D;}\n\t.st1{fill:#CF1B2B;}\n\t.st2{fill:#EEEEEE;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,90.2v87.6h125.1L0,90.2z M103.6,577.8h185.2V448.1L103.6,577.8z M511.1,448.1v129.7h185.2L511.1,448.1z  M0,400v87.6L125.1,400H0z M696.4,0H511.1v129.7L696.4,0z M800,487.6V400H674.9L800,487.6z M800,177.8V90.2l-125.1,87.6H800z  M288.9,0H103.6l185.2,129.7V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.7,400l215.8,151.1c10.5-10.9,18.1-24.2,22-38.9L636.2,400H558.7z M288.9,400h-47.6L25.5,551.1 c11.6,11.8,26.4,20.2,43.1,24.1L288.9,421V400z M511.1,177.8h47.6L774.5,26.7c-11.8-11.9-26.7-20.3-43-24.1L511.1,156.8V177.8z  M241.3,177.8L25.5,26.7C15,37.5,7.4,50.9,3.5,65.5l160.3,112.2H241.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M800,355.6H466.7v222.2h44.4V448.1l185.2,129.7h14.8c23.8,0,46.7-9.6,63.4-26.6L558.7,400h77.5l160.3,112.3 c2.1-7.5,3.5-15.2,3.5-23.4v-1.3L674.9,400H800V355.6z M0,355.6V400h125.1L0,487.6v1.3c0,24.2,9.8,46.2,25.5,62.2L241.3,400h47.6v21 L68.6,575.2c6.5,1.6,13.3,2.6,20.3,2.6h14.8l185.2-129.7v129.7h44.4V355.6H0z M800,88.9c0-23.3-9.2-45.6-25.5-62.2L558.7,177.8 h-47.6v-21L731.4,2.6C724.8,0.9,718,0.1,711.1,0h-14.7L511.1,129.7V0h-44.4v222.2H800v-44.4H674.9L800,90.2V88.9z M288.9,0v129.7 L103.6,0H88.9C65,0,42.2,9.6,25.5,26.7l215.8,151.1h-77.5L3.5,65.5C1.3,73.1,0.1,81,0,88.9v1.3l125.1,87.6H0v44.4h333.3V0H288.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.7,222.2V0H333.3v222.2H0v133.3h333.3v222.2h133.3V355.6H800V222.2H466.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UK_flag.d397f335cd543c6486564c34f1466a6f.svg";
export { ForwardRef as ReactComponent };